var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7499 6.25004V6.25837M3.33325 6.66671C3.33325 5.78265 3.68444 4.93481 4.30956 4.30968C4.93468 3.68456 5.78253 3.33337 6.66659 3.33337H13.3333C14.2173 3.33337 15.0652 3.68456 15.6903 4.30968C16.3154 4.93481 16.6666 5.78265 16.6666 6.66671V13.3334C16.6666 14.2174 16.3154 15.0653 15.6903 15.6904C15.0652 16.3155 14.2173 16.6667 13.3333 16.6667H6.66659C5.78253 16.6667 4.93468 16.3155 4.30956 15.6904C3.68444 15.0653 3.33325 14.2174 3.33325 13.3334V6.66671ZM7.49992 10C7.49992 10.6631 7.76331 11.299 8.23215 11.7678C8.70099 12.2366 9.33688 12.5 9.99992 12.5C10.663 12.5 11.2988 12.2366 11.7677 11.7678C12.2365 11.299 12.4999 10.6631 12.4999 10C12.4999 9.337 12.2365 8.70111 11.7677 8.23227C11.2988 7.76343 10.663 7.50004 9.99992 7.50004C9.33688 7.50004 8.70099 7.76343 8.23215 8.23227C7.76331 8.70111 7.49992 9.337 7.49992 10Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/InstagramIcon.a70bf4b2fb1f48d84a893b3b1ee299d4.svg";
export { ForwardRef as ReactComponent };